export default "__VITE_ASSET__B4i5brzs__"